import React from "react";
import { useState, useEffect } from "react";
import { Form, Button, Col, Row, Container, Modal } from "react-bootstrap";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import "./AñadidosModal.css";
import { saveImageToFirebaseStorage } from "../../../../util/UtilsFirebase";
import { addDoc, collection, deleteDoc, doc, setDoc } from "firebase/firestore";
import { projectFirestore } from "../../../../firebase/config";
const AñadidosModal = ({
  menu,
  showReceta,
  mod,
  categorias,
  itemAnadido,
  handleCloseAñadido,
}) => {
  const [initialAnadidoState, setAnadidoState] = useState({
    id: "",
    name: "",
    precio: "",
    free: false,
    categorias: [],
    medida: "",
    img: null,
  });
  const { register } = useAuthContext();
  const [image, setImage] = useState(null);

  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      if (e.target.name === "free") {
        setAnadidoState({
          ...initialAnadidoState,
          [e.target.name]: e.target.checked,
        });
      } else {
        const categorias = [...initialAnadidoState.categorias];
        if (categorias.includes(e.target.name)) {
          categorias.splice(categorias.indexOf(e.target.name), 1);
        } else {
          categorias.push(e.target.name);
        }
        setAnadidoState({
          ...initialAnadidoState,
          categorias: categorias,
        });
      }
    } else {
      setAnadidoState({
        ...initialAnadidoState,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleCloseLocal = async () => {
    setAnadidoState({
      id: "",
      name: "",
      precio: "",
      free: false,
      categorias: [],
      medida: "",
      img: null,
    });
    setImage(null);
    handleCloseAñadido();
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      const selectedImage = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(selectedImage);
        setAnadidoState({
          ...initialAnadidoState,
          img: reader.result,
        });
      };
      reader.readAsDataURL(selectedImage);
    }
  };

  const saveReceta = async () => {
    if (mod === "ADD") {
      const btn = document.getElementById("BtnGuardar");
      btn.disabled = true;
      if (initialAnadidoState.categorias.length === 0) {
        alert("El añadido requiere categorías");
        btn.disabled = false;
        return;
      }
      if (initialAnadidoState.name === "") {
        alert("El añadido requiere un nombre");
        btn.disabled = false;
        return;
      }
      if (initialAnadidoState.medida === "") {
        alert("El añadido requiere una medida");
        btn.disabled = false;
        return;
      }
      if (
        !initialAnadidoState.free &&
        (initialAnadidoState.precio === "" ||
          parseFloat(initialAnadidoState.precio) <= 0)
      ) {
        alert("El añadido requiere un precio");
        btn.disabled = false;
        return;
      } else {
        initialAnadidoState.precio = parseFloat(
          initialAnadidoState.precio
        ).toFixed(2);
      }
      let anadido = await addDoc(
        collection(projectFirestore, "menu", menu.id, "anadidos"),
        initialAnadidoState
      );
      let downloadURL = "";
      let path = "truck/" + register.id + "/menu/platillo/" + anadido.id + "/";

      if (image) {
        downloadURL = await saveImageToFirebaseStorage(path, image);
      }

      if (downloadURL) {
        setImage(downloadURL);
        initialAnadidoState.img = downloadURL;
      } else {
        setImage(
          "https://firebasestorage.googleapis.com/v0/b/rap-dis.appspot.com/o/NoDisponible.png?alt=media&token=a7fd0957-58f8-4f23-9351-d3393fcfe29c"
        );
        initialAnadidoState.img =
          "https://firebasestorage.googleapis.com/v0/b/rap-dis.appspot.com/o/NoDisponible.png?alt=media&token=a7fd0957-58f8-4f23-9351-d3393fcfe29c";
      }

      setDoc(
        doc(projectFirestore, "menu", menu.id, "anadidos", anadido.id),
        initialAnadidoState
      );
      handleCloseLocal();
    } else if (mod === "UPD") {
      const btn = document.getElementById("BtnGuardar");
      btn.disabled = true;
      if (initialAnadidoState.categorias.length === 0) {
        alert("El añadido requiere categorías");
        btn.disabled = false;
        return;
      }
      if (initialAnadidoState.name === "") {
        alert("El añadido requiere un nombre");
        btn.disabled = false;
        return;
      }
      if (initialAnadidoState.medida === "") {
        alert("El añadido requiere una medida");
        btn.disabled = false;
        return;
      }
      if (
        !initialAnadidoState.free &&
        (initialAnadidoState.precio === "" ||
          parseFloat(initialAnadidoState.precio) <= 0)
      ) {
        alert("El añadido requiere un precio");
        btn.disabled = false;
        return;
      } else {
        initialAnadidoState.precio = parseFloat(
          initialAnadidoState.precio
        ).toFixed(2);
      }

      let downloadURL = "";
      let path =
        "truck/" +
        register.id +
        "/menu/platillo/" +
        initialAnadidoState.id +
        "/";

      if (image) {
        downloadURL = await saveImageToFirebaseStorage(path, image);
      }

      if (downloadURL) {
        setImage(downloadURL);
        initialAnadidoState.img = downloadURL;
      }

      setDoc(
        doc(
          projectFirestore,
          "menu",
          menu.id,
          "anadidos",
          initialAnadidoState.id
        ),
        initialAnadidoState
      );
      handleCloseLocal();
    } else if (mod === "DLT") {
      const btn = document.getElementById("BtnGuardar");
      btn.disabled = true;
      await deleteDoc(
        doc(
          projectFirestore,
          "menu",
          menu.id,
          "anadidos",
          initialAnadidoState.id
        )
      );

      handleCloseLocal();
    }
  };

  useEffect(() => {
    if (showReceta) {
      if (mod === "UPD" || mod === "DLT") {
        setAnadidoState(itemAnadido);
      } else {
        setAnadidoState({
          id: "",
          name: "",
          precio: "",
          free: false,
          categorias: [],
          medida: "",
          img: null,
        });
      }
    }
  }, [showReceta, mod, menu, register.id, itemAnadido]);

  return (
    <Modal show={showReceta} onHide={handleCloseLocal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title> Añadidos </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              <Form>
                <div id="Ingredientes">
                  <Row>
                    <Col
                      md={3}
                      style={{ textAlign: "right", paddingTop: "8px" }}
                    >
                      Nombre:
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formName">
                        <Form.Control
                          type="text"
                          name="name"
                          disabled={mod === "DLT" ? mod : ""}
                          value={initialAnadidoState.name}
                          placeholder="Ingresa un nombre"
                          onChange={(e) => handleChange(e)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}></Col>
                  </Row>
                  <br />
                  <Row>
                    <Col
                      md={3}
                      style={{ textAlign: "right", paddingTop: "15px" }}
                    >
                      Precio unitario:
                    </Col>
                    <Col md={6} style={{ paddingTop: "5px" }}>
                      <Form.Group controlId="formName">
                        <Form.Control
                          type="number"
                          name="precio"
                          placeholder="0.00"
                          disabled={
                            mod === "DLT" ? mod : initialAnadidoState.free
                          }
                          value={
                            initialAnadidoState.free
                              ? "0.00"
                              : initialAnadidoState.precio
                          }
                          onChange={(e) => handleChange(e)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <div>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="free"
                          disabled={mod === "DLT" ? mod : ""}
                          checked={initialAnadidoState.free}
                          onChange={(e) => handleChange(e)}
                          id="flexSwitchCheckDefault"
                        />
                        <label
                          className="lblqrdinamico"
                          style={{
                            paddingTop: "15px",
                            paddingLeft: "20px",
                          }}
                        >
                          Gratis
                        </label>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col
                      md={3}
                      style={{ textAlign: "right", paddingTop: "8px" }}
                    >
                      Unidad de medida:
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formName">
                        <Form.Control
                          type="text"
                          name="medida"
                          disabled={mod === "DLT" ? mod : ""}
                          value={initialAnadidoState.medida}
                          placeholder="Ingresa una unidad de medida"
                          onChange={(e) => handleChange(e)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}></Col>
                  </Row>
                  <br />
                  <Row>
                    <Col
                      md={3}
                      style={{ textAlign: "right", paddingTop: "8px" }}
                    >
                      Categorias vinculadas:
                    </Col>
                    <Col md={6}>
                      <div
                        className="scrollcat"
                        disabled={mod === "DLT" ? mod : ""}
                      >
                        {categorias.map((val, index) => (
                          <Row>
                            <input
                              style={{
                                marginTop: "10px !important",
                                marginBottom: "0px !important",
                                marginLeft: "0px !important",
                              }}
                              className="form-check-input"
                              type="checkbox"
                              disabled={mod === "DLT" ? mod : ""}
                              name={val.name}
                              checked={
                                initialAnadidoState.categorias.includes(
                                  val.name
                                )
                                  ? true
                                  : false
                              }
                              onChange={(e) => handleChange(e)}
                              id="flexSwitchCheck"
                            />
                            <label
                              className="lblqrdinamico"
                              style={{
                                paddingTop: "10px",
                                paddingLeft: "20px",
                                width: "10px",
                              }}
                            >
                              {val.name}
                            </label>
                          </Row>
                        ))}
                      </div>
                    </Col>
                    <Col md={3}></Col>
                  </Row>
                  <br />
                  <Row>
                    <Col
                      md={3}
                      style={{ textAlign: "right", paddingTop: "8px" }}
                    >
                      Foto:
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="modoOP">
                        <div className="">
                          <label
                            style={{ border: "1px solid gray", margin: "0px" }}
                          >
                            <img
                              id="logo_img"
                              alt="Haga click para asignar una imagen"
                              src={initialAnadidoState.img}
                              height="150"
                              width="200"
                            />
                            <input
                              id="logoNeg"
                              type="file"
                              disabled={mod === "DLT" ? mod : ""}
                              style={{ display: "none" }}
                              accept="image/png, image/jpeg"
                              multiple={false}
                              onChange={handleImageChange}
                            />
                          </label>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={3}></Col>
                  </Row>
                </div>
                <br />
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseLocal}>
          CANCELAR
        </Button>
        <Button
          id="BtnGuardar"
          variant={mod && mod === "DLT" ? "danger" : "primary"}
          onClick={saveReceta}
        >
          {mod && mod === "DLT" ? "ELIMINAR" : "GUARDAR"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AñadidosModal;
